<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="right">Copyright</p>
<p class="crt">Henrietta<br/>Copyright ©1979 by Marion Chesney<br/>Cover art to the electronic edition copyright © 2011 by RosettaBooks, LLC</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles or reviews.</p>
<p class="crt">First electronic edition published 2011 by RosettaBooks LLC, New York.<br/>ISBN e-Pub edition: 9780795319648</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795319648_epub_cop_r1.vue?781daeeb